import { render, staticRenderFns } from "./RootContrattiTerminatiView.vue?vue&type=template&id=8c1b20de&"
import script from "./RootContrattiTerminatiView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiTerminatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports